class CustomAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.slides = this.querySelectorAll('.announcement-slide');
    this.prevBtn = this.querySelector('.prev-btn');
    this.nextBtn = this.querySelector('.next-btn');
    this.currentIndex = 0;
    this.totalSlides = this.slides.length;
    this.autoplayEnabled = this.dataset.autoplay === 'true';
    this.autoplayDelay = parseInt(this.dataset.delay) || 5000;
    this.autoplayTimer = null;

    if (this.totalSlides < 2) {
      if (this.prevBtn) this.prevBtn.style.display = 'none';
      if (this.nextBtn) this.nextBtn.style.display = 'none';
      return;
    }

    this.init();
  }

  init() {
    this.prevBtn.addEventListener('click', () => {
      this.pauseAutoplay();
      this.prevSlide();
    });

    this.nextBtn.addEventListener('click', () => {
      this.pauseAutoplay();
      this.nextSlide();
    });

    if (this.autoplayEnabled) {
      this.startAutoplay();
      this.addEventListener('mouseenter', () => this.pauseAutoplay());
      this.addEventListener('mouseleave', () => this.startAutoplay());
    }
  }

  showSlide(index) {
    this.slides.forEach((slide, i) => {
      slide.classList.remove('active');
      slide.style.position = 'absolute'; // Reset position
      if (i === index) {
        slide.classList.add('active');
        slide.style.position = 'relative'; // Ensure flow
      }
    });
    this.currentIndex = index;
  }

  nextSlide() {
    let newIndex = this.currentIndex + 1;
    if (newIndex >= this.totalSlides) {
      newIndex = 0;
    }
    this.showSlide(newIndex);
  }

  prevSlide() {
    let newIndex = this.currentIndex - 1;
    if (newIndex < 0) {
      newIndex = this.totalSlides - 1;
    }
    this.showSlide(newIndex);
  }

  startAutoplay() {
    if (this.autoplayTimer) return;
    this.autoplayTimer = setInterval(() => {
      this.nextSlide();
    }, this.autoplayDelay);
  }

  pauseAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }
}

if (!customElements.get('custom-announcement-bar')) {
  customElements.define('custom-announcement-bar', CustomAnnouncementBar);
}
